// Module
var code = "<div class=\"h100\" ng-controller=\"VueRouterWrapperCtrl\" ng-cloak> <vue-component class=\"h100\" name=\"VueRouterWrapper\" router=\"router\"/> </div> ";
// Exports
module.exports = code;